import { BaseEntity } from 'src/app/tools/models/baseEntity';


export class GeoAreaType extends BaseEntity {

    geoAreaTypeCode    : string;
    name               : string;
    rank               : number;

}